import React from 'react';

function DocumentYellowIcon() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M31.6499 14.9833L31.6666 16.675V31.6667C31.6666 32.5507 31.3154 33.3986 30.6903 34.0237C30.0652 34.6488 29.2173 35 28.3333 35H11.6666C10.7825 35 9.93468 34.6488 9.30956 34.0237C8.68444 33.3986 8.33325 32.5507 8.33325 31.6667V8.33333C8.33325 7.44928 8.68444 6.60143 9.30956 5.97631C9.93468 5.35119 10.7825 5 11.6666 5H20.4583C21.2399 5 21.9949 5.27333 22.5949 5.77333L31.0516 12.8333C31.4299 13.15 31.6499 13.6183 31.6499 14.1133V14.9817V14.9833ZM20.0333 8.33333L19.9999 13.6533C19.9997 13.8707 20.0424 14.086 20.1257 14.2868C20.2089 14.4876 20.331 14.67 20.485 14.8235C20.6389 14.977 20.8217 15.0985 21.0227 15.1812C21.2238 15.2638 21.4392 15.3059 21.6566 15.305H28.3233L20.0333 8.33333Z"
                fill="#FBB414"
            />
        </svg>
    );
}

export default DocumentYellowIcon;
